// This file is auto-generated by Kubb. Do not edit manually.
/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const payerSchema = z.object({
  id: z.string().describe("Payer id"),
  name: z.string().describe("Payer name"),
});
